export const ADDITIONAL_HOURS: number = 1;
export const MIN_PIN_DURATION: number = 1  // 1 minute
export const OFFSET_HOURS: number = 2;